import { Component } from '@angular/core';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-line-semantics-time-series-bloom',
  templateUrl: './line-semantics-time-series-bloom.component.html',
  styleUrl: './line-semantics-time-series-bloom.component.scss',
})
export class LineSemanticsTimeSeriesBloomComponent {
  isLoading = true;

  label: any = {
    show: true,
    position: 'inside',
    formatter: (params) =>
      params.value >= 5 ? parseInt(params.value) + '%' : '',
    fontWeight: 'bold',
    color: '#fff',
  };

  options: echarts.EChartsOption = {
    grid: { left: 20, right: 30, top: 40, bottom: 80 },
    stack: 'total',
    yAxis: {
      max: 100,
      axisLabel: {
        formatter: '{value}%', // append percentage sign to labels
      },
    },

    series: [
      {
        type: 'bar',
        stack: 'total',
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
      {
        label: this.label,
      },
    ],
  };

  constructor(protected analyticsService: AnalyticsService) {
    this.analyticsService.semanticsTimeSeriesBloom$.subscribe((data) => {});
    this.analyticsService.isLoading$.subscribe((loading) => {
      this.isLoading = loading.includes('semanticsTimeSeriesBloom');
    });
    this.getChartData();
  }

  getChartData() {
    this.analyticsService.getSemanticsTimeSeriesBloom().subscribe();
  }

  get series() {
    return this.analyticsService.semanticsTimeSeriesBloom$.value?.series;
  }

  get labels() {
    return this.analyticsService.semanticsTimeSeriesBloom$.value?.labels;
  }
}
